module.exports = __webpack_public_path__ + "img/全景智联智慧制造商家服务系统.6e49a09f.jpg";